import { render, staticRenderFns } from "./LeaveComplianceRiskOverview.vue?vue&type=template&id=300bb437&scoped=true"
import script from "./LeaveComplianceRiskOverview.vue?vue&type=script&lang=js"
export * from "./LeaveComplianceRiskOverview.vue?vue&type=script&lang=js"
import style0 from "./LeaveComplianceRiskOverview.vue?vue&type=style&index=0&id=300bb437&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300bb437",
  null
  
)

export default component.exports